<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader" *ngIf="!isMyProfile"></app-content-header>
    <div class="row" *ngIf="currentUser">
      <div class="col-lg-3 col-12">
        <div class="card">
          <div class="card-body text-center">
            <div class="mb-1">
              <img *ngIf="currentUser.avatar !== null && currentUser.avatar.length > 0" [alt]="currentUser.firstname + ' ' + currentUser.lastname" [src]="currentUser.avatar" class="rounded contain w-100" width="300" height="300" />
              <div id="fake-avatar" class="rounded" *ngIf="currentUser.avatar === null || currentUser.avatar.length < 1">
                <span>{{ currentUser.firstname | initials }}{{ currentUser.lastname | initials }}</span>
              </div>
            </div>
            <h3 class="mb-05">{{ currentUser.complete_name }}</h3>
            <div class="badge badge-light-primary profile-badge mr-1" [ngbTooltip]="'ROLE' | translate" *ngIf="currentUser.role && _authenticationService.hasCapability('view_user_role')">{{ currentUser.role }}</div>
            <div class="badge badge-light-info profile-badge" *ngIf="currentUser.site" [ngbTooltip]="'JOB_SITE' | translate">{{ currentUser.site }}</div>
            <div class="d-flex justify-content-center align-items-center mt-2">
              <a href="mailto:{{ currentUser.email }}" [ngbTooltip]="currentUser.email">
                <i size="24" [data-feather]="'mail'"></i>
              </a>
              <a *ngFor="let social of currentUser.socials" [href]="social.url" target="_blank" [class]="'ml-1 text-' + social.name" [ngbTooltip]="social.name">
                <i size="24" [data-feather]="social.name"></i>
              </a>
            </div>
          </div>
        </div>
        <!-- Documents -->
        <div class="card my-padding" *ngIf="_authenticationService.hasCapability('view_others_documents') || isMyProfile">
          <div class="d-flex align-items-center cursor-pointer" [routerLink]="isMyProfile ? '/dashboard/my-documents' : '/dashboard/documents-list'"
               [queryParams]="{ search: !isMyProfile ? currentUser.complete_name : null, ref: '/dashboard/user/profile/' + currentUser.hash }">
            <div class="w-fit avatar avatar-lg bg-light-warning">
              <div class="avatar-content">
                <i [data-feather]="'folder'"></i>
              </div>
            </div>
            <div class="ml-2">
              <h4 class="mb-0">{{ "DOCUMENTS_AREA" | translate }}</h4>
            </div>
          </div>
        </div>
        <!-- Curriculum -->
        <div class="card my-padding" *ngIf="(_authenticationService.hasCapability('view_others_curriculum') || isMyProfile) && !_utilService.isACollaborator(currentUser)">
          <div class="d-flex align-items-center cursor-pointer" [routerLink]="'/dashboard/user/profile/' + currentUser.hash + '/curriculum'">
            <div class="w-fit avatar avatar-lg bg-light-info">
              <div class="avatar-content">
                <i [data-feather]="'server'"></i>
              </div>
            </div>
            <div class="ml-2">
              <h4 class="mb-0">{{ "TITLES.CURRICULUM" | translate }}</h4>
            </div>
          </div>
        </div>
        <!-- Contratto -->
        <div class="card my-padding" *ngIf="_authenticationService.hasCapability('view_others_contracts') && !isMyProfile && !_utilService.isACollaborator(currentUser)">
          <div class="d-flex align-items-center cursor-pointer" (click)="goToContract()">
            <div class="w-fit avatar avatar-lg bg-light-primary">
              <div class="avatar-content">
                <i [data-feather]="'box'"></i>
              </div>
            </div>
            <div class="ml-2">
              <h4 class="mb-0">{{ "CONTRACT" | translate }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-9 col-12 printRef">
        <!-- Anagrafica-->
        <div class="card">
          <div class="card-header d-flex align-items-center px-2 border-bottom">
            <h4 class="mb-0">{{ "MASTERDATA" | translate }}</h4>
          </div>
          <!-- Address And Contact Starts -->
          <div class="card-body invoice-padding pt-1 pb-3 px-1">
            <div class="invoice-spacing">
              <div class="col-12 mb-4" *ngIf="currentUser?.address || currentUser?.department || currentUser?.figure || currentUser?.birthday || currentUser?.birth_place || currentUser.email || currentUser.phone">
                <div class="row">
                  <div class="col-lg-6 col-12 mt-1" *ngIf="(isMyProfile || _authenticationService.hasCapability('view_user_address')) && currentUser?.address && currentUser?.address.city_name && currentUser?.address.province_name">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "RESIDENCE_CITY" | translate }}:</label>
                    <span>{{ currentUser?.address?.city_name + " (" + currentUser?.address?.province_name + ")" }}</span>
                  </div>
                  <div class="col-lg-6 col-12 mt-1" *ngIf="currentUser?.address && currentUser?.address?.street && currentUser?.address?.zipcode && currentUser?.address?.city_name && currentUser?.address?.province_name">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "ADDRESS_STREET" | translate }}:</label>
                    <span>{{ currentUser.address.street }} {{ currentUser.address.zipcode + ", " + currentUser.address.city_name + " (" + currentUser.address.province_name + ")" }}</span>
                  </div>
                  <!-- indirizzo estero -->
                  <div class="col-lg-6 col-12 mt-1" *ngIf="currentUser?.address && currentUser?.address.street && !currentUser?.address.city_name && !currentUser?.address.zipcode && !currentUser?.address.province_name">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "ADDRESS_STREET" | translate }}:</label>
                    <span>{{ currentUser.address.residenza.street }} </span>
                  </div>
                  <div class="col-lg-6 col-12 mt-1" *ngIf="currentUser?.figure_name">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "FIGURE" | translate }}:</label>
                    <span>{{ currentUser.figure_name }}</span>
                  </div>
                  <div class="col-lg-6 col-12 mt-1" *ngIf="currentUser?.birthday">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "BIRTHDAY" | translate }}:</label>
                    <span>{{ _utilService.formatDate(currentUser.birthday) }}</span>
                  </div>
                  <div class="col-lg-6 col-12 mt-1" *ngIf="currentUser?.birth_place">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "BIRTH_PLACE" | translate }}:</label>
                    <span>{{ currentUser.birth_place }}</span>
                  </div>
                  <div class="col-lg-6 col-12 mt-1" *ngIf="currentUser?.phone">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "PRIVATE_PHONE" | translate }}:</label>
                    <a [href]="'tel:' + currentUser.phone" [ngbTooltip]="'CALL' | translate">{{ currentUser.phone }}</a>
                  </div>
                  <div class="col-lg-6 col-12 mt-1" *ngIf="currentUser?.email">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "PRIVATE_EMAIL" | translate }}:</label>
                    <a href="mailto:{{ currentUser.email }}" [ngbTooltip]="'SEND_EMAIL' | translate">{{ currentUser.email }} </a>
                  </div>
                </div>
              </div>
              <div
                class="col-12"
                *ngIf="
                  currentUser.hr_name ||
                  currentUser.working_city_name ||
                  currentUser.identity_document?.nationality ||
                  currentUser.type ||
                  currentUser.fiscal_code ||
                  currentUser.has_welcomebox !== null ||
                  currentUser.send_onboarding !== null ||
                  (currentUser.contract && currentUser.contract.start_date) ||
                  currentUser.education ||
                  currentUser.civil_status ||
                  currentUser.has_child !== null ||
                  currentUser.IBAN ||
                  currentUser.vat_number ||
                  currentUser.need_assets !== null
                "
              >
                <h4>{{ "INFO" | translate }}</h4>
                <div class="row">
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.working_city_name">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "CITY" | translate }}:</label>
                    <span>{{ currentUser.working_city_name }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.identity_document?.nationality">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "NATIONALITY" | translate }}:</label>
                    <span>{{ currentUser.identity_document?.nationality }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.fiscal_code">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "FISCAL_CODE" | translate }}:</label>
                    <span>{{ currentUser.fiscal_code }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.contract && currentUser.contract.start_date">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "ASSUMPTION_DATE" | translate }}:</label>
                    <span>{{ _utilService.formatDate(currentUser.contract.start_date) }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.education_title_name || currentUser.education_graduate_name || currentUser.education_subject">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "EDUCATION_TITLE" | translate }}:</label>
                    <span>{{ currentUser.education_title_name }} {{ currentUser.education_graduate_name || currentUser.education_subject }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="(currentUser && currentUser.contract && currentUser.contract?.desired_total_daily) || (currentUser && currentUser.total_daily)">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "ESTIMATED_DAILY_COST" | translate }}:</label>
                    <span *ngIf="currentUser && currentUser.total_daily">{{ _utilService.addDotsToNumber(currentUser.total_daily) }} &euro;</span>
                    <span *ngIf="currentUser && currentUser.contract && currentUser.contract?.desired_total_daily && !currentUser.total_daily"
                    >{{ _utilService.addDotsToNumber(currentUser.contract?.desired_total_daily) }} &euro;</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Esperienze, competenze e certificazioni -->
        <div
          class="card"
          id="eccTale"
          *ngIf="(currentUser.skills && currentUser.skills.length > 0) || (currentUser.certifications && currentUser.certifications.length > 0) || (currentUser.languages && currentUser.languages.length > 0)"
        >
          <div class="card-body pt-1 pb-0">
            <nav class="d-flex" [ngClass.sm]="'flex-wrap justify-content-around'" [ngClass.xl]="'align-items-center justify-content-between'" [ngClass.md]="'align-items-center justify-content-between flex-wrap'">
              <li *ngIf="currentUser.skills && currentUser.skills.length > 0">
                <a (click)="eccTableIndex = 'skill'" [class]="eccTableIndex === 'skill' ? 'current' : ''">{{ "SKILLS" | translate }}</a>
              </li>
              <li *ngIf="currentUser.educations && currentUser.educations.length > 1">
                <a (click)="eccTableIndex = 'educations'" [class]="eccTableIndex === 'educations' ? 'current' : ''">{{ "EDUCATION_ONBOARDING" | translate }}</a>
              </li>
              <li *ngIf="currentUser.certifications && currentUser.certifications.length > 0">
                <a (click)="eccTableIndex = 'certification'" [class]="eccTableIndex === 'certification' ? 'current' : ''">{{ "CERTIFICATIONS" | translate }}</a>
              </li>
              <li *ngIf="currentUser.languages && currentUser.languages.length > 0">
                <a (click)="eccTableIndex = 'language'" [class]="eccTableIndex === 'language' ? 'current' : ''">{{ "LANGUAGES" | translate }}</a>
              </li>
            </nav>
            <div *ngIf="eccTableIndex === 'skill'">
              <ngx-datatable
                *ngIf="currentUser.skills && currentUser.skills.length > 0"
                class="bootstrap core-bootstrap"
                [ngClass.md]="'heightDatatable'"
                columnMode="force"
                [headerHeight]="50"
                [scrollbarH]="true"
                [scrollbarV]="_utilService.isDesktop"
                [rowHeight]="_utilService.isDesktop ? 70 : 80"
                [footerHeight]="_utilService.isDesktop ? 50 : 0"
                [limit]="10"
                [rows]="currentUser.skills"
              >
                <ngx-datatable-column [name]="'SINGLE_COMPETENCE' | translate" prop="name" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.skill_name }}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'LEVEL' | translate" prop="level" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.level }}</span>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <p *ngIf="currentUser.skills === null || currentUser.skills.length < 1" class="no-items font-medium-1">
                {{ "NO_SKILL_FOR_THIS_USER" | translate }}
              </p>
            </div>
            <div *ngIf="eccTableIndex === 'educations'">
              <ngx-datatable
                *ngIf="currentUser.educations && currentUser.educations.length > 1"
                class="bootstrap core-bootstrap"
                [ngClass.md]="'heightDatatable'"
                columnMode="force"
                [headerHeight]="50"
                [scrollbarH]="true"
                [scrollbarV]="!_utilService.isDesktop"
                [rowHeight]="_utilService.isDesktop ? 70 : 80"
                [footerHeight]="_utilService.isDesktop ? 50 : 0"
                [limit]="10"
                [rows]="currentUser.educations"
              >
                <ngx-datatable-column [name]="'TITLE' | translate" prop="title_name" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.title_name }} {{ row.graduate_name || row.subject }} </span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'EDUCATION_VOTE' | translate" prop="vote" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.vote || "-" }}</span>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>

            <div *ngIf="eccTableIndex === 'certification'">
              <ngx-datatable
                *ngIf="currentUser.certifications && currentUser.certifications.length > 0"
                class="bootstrap core-bootstrap"
                [ngClass.md]="'heightDatatable'"
                columnMode="force"
                [headerHeight]="50"
                [scrollbarH]="true"
                [scrollbarV]="_utilService.isDesktop"
                [rowHeight]="_utilService.isDesktop ? 70 : 90"
                [footerHeight]="_utilService.isDesktop ? 50 : 0"
                [limit]="10"
                [rows]="currentUser.certifications"
              >
                <ngx-datatable-column [name]="'SINGLE_COMPETENCE' | translate" prop="name" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.name }}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'LINK' | translate" prop="proof" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.proof }}</span>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <p *ngIf="currentUser.skills === null || currentUser.certifications.length < 1" class="no-items font-medium-1">
                {{ "NO_CERTIFICATION_FOR_THIS_USER" | translate }}
              </p>
            </div>
            <div *ngIf="eccTableIndex === 'language'">
              <ngx-datatable
                *ngIf="currentUser.languages && currentUser.languages.length > 0"
                class="bootstrap core-bootstrap"
                [ngClass.md]="'heightDatatable'"
                columnMode="force"
                [headerHeight]="50"
                [scrollbarH]="true"
                [scrollbarV]="_utilService.isDesktop"
                [rowHeight]="_utilService.isDesktop ? 70 : 80"
                [footerHeight]="_utilService.isDesktop ? 50 : 0"
                [limit]="10"
                [rows]="currentUser.languages"
              >
                <ngx-datatable-column [name]="'NAME' | translate" prop="name" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.name }}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'LEVEL_SPEAK' | translate" prop="speak" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.speak }}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'LEVEL_WRITE' | translate" prop="write" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.write }}</span>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <p *ngIf="currentUser.languages === null || currentUser.languages.length < 1" class="no-items font-medium-1">
                {{ "NO_LANGUAGES_FOR_THIS_USER" | translate }}
              </p>
            </div>
          </div>
        </div>
        <!-- Ferie, permessi e malattie -->
        <div class="card" *ngIf="isMyProfile || _authenticationService.hasCapability('view_ferie_permessi')">
          <div class="card-body p-0">
            <div class="d-flex align-items-center justify-content-start px-2 py-1 text-uppercase bg-table-header-dark">
              <h4 class="text-primary flex-basis-50 font-small-3 font-weight-bolder m-0">{{ "DEMANDS.HOLIDAYS" | translate }} , {{ "DEMANDS.PERMISSIONS" | translate }}, {{ "DEMANDS.SICKNESS" | translate }}</h4>
              <div class="font-weight-bold text-secondary font-small-3" [ngClass.sm]="'flex-basis-20'" [ngClass.xl]="'flex-basis-30'" [ngClass.md]="'flex-basis-30'">{{ "DAYS" | translate }}</div>
              <div class="text-right" [ngClass.sm]="'flex-basis-30'" [ngClass.xl]="'flex-basis-20'" [ngClass.md]="'flex-basis-20'">
                <select class="form-control text-capitalize" (change)="allAbsences($event)">
                  <option selected disabled="disabled" value="2023">{{ "YEAR" | translate }}</option>
                  <option *ngFor="let year of last5years" [value]="year">{{ year }}</option>
                </select>
              </div>
            </div>
            <div
              class="d-flex align-items-center justify-content-start border-top px-2 py-1 text-secondary cursor-pointer"
              *ngFor="let item of all_absences"
              (click)="openModalAbsences(modalAbsences, item.name, selectedYearAbsence)"
            >
              <div class="flex-basis-50">{{ item.name === "ferie" ? ("DEMANDS.HOLIDAYS" | translate) : item.name === "permesso" ? ("DEMANDS.PERMISSIONS" | translate) : ("DEMANDS.SICKNESS" | translate) }}</div>
              <div class="flex-basis-50">{{ item.amount }}{{ item.name === "permesso" ? "h" : "" }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" *ngIf="this._authenticationService.hasCapability('view_users_notes')">
        <div class="card">
          <div class="card-title px-2 pt-2 m-0">
            <h4 class="m-0">{{ "NOTES" | translate }}</h4>
          </div>
          <section class="card-body">
            <div id="list-notes" *ngIf="currentUser && currentUser.notes && currentUser.notes.length > 0">
              <div class="note" *ngFor="let note of currentUser.notes; let index = index">
                <header class="note-header">
                  {{ _utilService.formatDate(note.create_date) }} -
                  <strong>{{ note.create_by_complete_name }}</strong>
                </header>
                <div class="note-content" [innerHTML]="note.note"></div>
              </div>
            </div>
            <h4 *ngIf="!currentUser.notes || !currentUser.notes || currentUser.notes.length < 1" class="font-medium-1 font-weight-normal">{{ "NO_NOTES" | translate }}</h4>
          </section>
        </div>
      </div>
      <!-- Bacheca premi-->
      <div class="col-4 col-lg-4 card px-0" *ngIf="config.enable_gamification && (isMyProfile || _authenticationService.hasCapability('view_user_gamification'))">
        <div class="d-flex justify-content-center">
          <img src="/src/assets/images/elements/decore-left.png" class="w-50" alt="card-img-left" />
          <img src="/src/assets/images/elements/decore-right.png" class="w-50" alt="card-img-right" />
        </div>
        <div class="row mb-2 mt-2">
          <div class="w-fit mx-auto">
            <img src="../../../../../../assets/images/illustration/badge.svg" alt="Medal Pic" />
          </div>
        </div>
        <div class="col-12 text-center mb-5">
          <h4>{{ "AWARDS_BOARD" | translate }}</h4>
          <small class="card-text mx-auto"> You have done <strong>57.6%</strong> of our challenges.<br />Check your new badge and stay ready for the next one. </small>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Absences -->
<ng-template #modalAbsences let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ "RESUME" | translate }} {{ demand_modal_data[0].category }}</h4>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-0" tabindex="0">
    <table class="table">
      <thead>
      <th class="bt-0 text-primary">{{ "CATEGORY" | translate }}</th>
      <th class="bt-0">{{ "FROM" | translate }} / {{ "TO" | translate }}</th>
      </thead>
      <tbody>
      <tr *ngFor="let demand of demand_modal_data">
        <td class="text-capitalize">{{ demand.type.category }}</td>
        <td>{{ demand.date_from }} - {{ demand.date_to }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</ng-template>
<!-- / Modal Absences -->

<!-- Modal Experience -->
<ng-template #modalExperience let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ "EXPERIENCE_DETAIL" | translate }}</h4>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <div class="row">
      <div class="form-group col-lg-6 col-12 font-medium-1 d-flex align-items-center">
        <div class="font-weight-bold">{{ "AGENCY_NAME" | translate }}:&nbsp;&nbsp;</div>
        <div>{{ currentExperience.agency || "-" }}</div>
      </div>
      <div class="form-group col-lg-6 col-12 font-medium-1 d-flex align-items-center">
        <div class="font-weight-bold">{{ "CUSTOMER" | translate }}:&nbsp;&nbsp;</div>
        <div>{{ currentExperience.customer || "-" }}</div>
      </div>
      <div class="form-group col-lg-3 col-12 font-medium-1 d-flex align-items-center">
        <div class="font-weight-bold">{{ "FROM" | translate }}:&nbsp;&nbsp;</div>
        <div>{{ currentExperience.from ? _utilService.formatDate(currentExperience.from) : "-" }}</div>
      </div>
      <div class="form-group col-lg-3 col-12 font-medium-1 d-flex align-items-center">
        <div class="font-weight-bold">{{ "TO" | translate }}:&nbsp;&nbsp;</div>
        <div>{{ currentExperience.to ? _utilService.formatDate(currentExperience.to) : "-" }}</div>
      </div>
      <div class="form-group col-lg-6 col-12 font-medium-1 d-flex align-items-center">
        <div class="font-weight-bold">{{ "FIGURE" | translate }}:&nbsp;&nbsp;</div>
        <div>{{ currentExperience.figure || "-" }}</div>
      </div>
      <div class="form-group col-12 font-medium-1 d-flex align-items-center">
        <div class="font-weight-bold">{{ "DOMAIN" | translate }}:&nbsp;&nbsp;</div>
        <div>{{ currentExperience.domain_name || "-" }}</div>
      </div>
      <div class="form-group col-12 font-medium-1 d-flex">
        <div class="font-weight-bold">{{ "TECNOLOGIES" | translate }}:&nbsp;&nbsp;</div>
        <div>
          <span *ngFor="let skill of currentExperience.skill_names" class="badge badge-pill badge-light-secondary mb-05 mr-075">{{ skill }}</span>
        </div>
      </div>
      <div class="form-group col-12 font-medium-1">
        <div class="font-weight-bold mb-05">{{ "DESCRIPTION" | translate }}</div>
        <em>{{ currentExperience.description || "-" }}</em>
      </div>
    </div>
  </div>
</ng-template>
<!-- / Modal Absences -->
